import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  'article-1': 'https://readdy.ai/api/search-image?query=Modern%20creative%20studio%20workspace%20with%20warm%20lighting%2C%20minimalist%20design%2C%20content%20creation%20atmosphere%2C%20clean%20aesthetic&width=800&height=480&seq=mitao-case-01&orientation=landscape',
  'article-2': 'https://readdy.ai/api/search-image?query=Social%20media%20marketing%20dashboard%20with%20analytics%20charts%2C%20warm%20tone%2C%20modern%20office%20setup%2C%20professional%20environment&width=800&height=480&seq=mitao-case-02&orientation=landscape',
  'article-3': 'https://readdy.ai/api/search-image?query=Professional%20video%20production%20equipment%20setup%2C%20warm%20studio%20lighting%2C%20camera%20and%20lighting%20gear%2C%20creative%20atmosphere&width=800&height=480&seq=mitao-case-03&orientation=landscape',
  'article-4': 'https://readdy.ai/api/search-image?query=Brand%20strategy%20meeting%20with%20creative%20team%2C%20modern%20office%2C%20warm%20atmosphere%2C%20collaborative%20workspace&width=800&height=480&seq=mitao-case-04&orientation=landscape',
  'article-5': 'https://readdy.ai/api/search-image?query=Short%20video%20editing%20workstation%20with%20timeline%20display%2C%20warm%20ambient%20light%2C%20professional%20setup&width=800&height=480&seq=mitao-case-05&orientation=landscape',
  'article-6': 'https://readdy.ai/api/search-image?query=Digital%20marketing%20analytics%20on%20screen%2C%20warm%20modern%20office%2C%20data%20visualization%2C%20professional%20workplace&width=800&height=480&seq=mitao-case-06&orientation=landscape',
};

export default function Cases() {
  const latestArticles = getLatestArticles(6);

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-12 md:mb-14">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              精选内容
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              最新内容洞察与案例分享
            </h2>
          </div>
          <Link
            to="/category/short-video"
            className="flex items-center gap-1 text-primary-600 text-sm font-medium hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:translate-y-[-2px]"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={articleImages[article.id] || articleImages['article-1']}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-700 text-xs font-medium">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}